import styled from "styled-components";

export const CustomeSwipeList = styled.div`
	.swipe-list {
		position: relative;
		}

		.box-action {
		position: absolute;
		right: 0;
		height: 100%
		}

		.item-group {
		overflow: hidden;
		background: #ccc;
		}

		.item {
		background: #fff;
		position: relative;
		z-index: 2;
		transition: all 0.1s linear;
	}
`;
